import React, { useRef, useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Card, CardBody, Form, Row, Container, Col,  Alert } from "reactstrap"

import Breadcrumbs from "../../../../components/Common/Breadcrumb"

import * as Yup from "yup"
import { useFormik, Field } from "formik"

// Redux
import { useSelector, useDispatch } from "react-redux"
import AudianceAndTicketing from "./AudianceAndTicketing"
import TicketPricing from "./TicketPricing"
import FoodPricing from "./FoodPricing"
import DeliveryAccess from "./DeliveryAccess"
import VenueStep from "./VenueStep"
import TicketFoodPricing from "./TicketFoodPricing"
import { createTicketVenue, resetVenue } from "toolkitStore/ticketMSlice/TicketVenueSlice"

const TicketVenue = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { TicketVenueisSuccessfully, isUserEdit } = useSelector(
    state => state.TicketVenueReducer
  )

  const [selectedData, SetSelectData] = useState()

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
  // console.log("event_id", event_id_c)
  const venue_id_c = JSON.parse(localStorage.getItem("venue_id"))
  const [activeStep, setActiveStep] = useState(1)
  const [openSection, setOpenSection] = useState(null)
  // console.log("venue_id_c -->", venue_id_c)

  const [draftVenueId, setDraftVenueId] = useState(null)

  const nfds = []
  for (let i = 1; i <= event_id_c.EventDay; i++) {
    nfds.push(i)
  }
  const toggleSection = section => {
    setOpenSection(prev => (prev === section ? null : section))
  }


  useEffect(() => {

    const editData = JSON.parse(localStorage.getItem("editUser"))

    if (editData) {
      SetSelectData(editData)

      setDraftVenueId(editData._id)
      localStorage.setItem("venueDraftId", editData._id)
    }

  }, [])

  useEffect(() => {
    const storedId = localStorage.getItem("venueDraftId")
    if (storedId) {
      setDraftVenueId(storedId)
    }
  }, [])

  const toLocalDateTime = (utcDate) => {
  if (!utcDate) return "";
  const date = new Date(utcDate);

  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60000);

  return local.toISOString().slice(0, 16);
};


const toUTCISOString = (localDate) => {
  if (!localDate) return null;
  return new Date(localDate).toISOString();
};


  const buildBookingLimits = (values) => {
    const limits = []
    const type = values.bookingType

 

   const pushLimit = (audience, ticketLimit, foodLimit) => {
  const obj = {
    audience_type: audience
  }

  if (type === "ticket_booking") {
    obj.max_tickets_per_booking = Number(ticketLimit) || 0
  }

  if (type === "food_booking") {
    obj.max_food_per_booking = Number(foodLimit) || 0
  }

  if (type === "ticket_food_booking") {
    obj.max_tickets_per_booking = Number(ticketLimit) || 0
    obj.max_food_per_booking = Number(foodLimit) || 0
  }

  limits.push(obj)
}

    if (values.isMember) {
    
      pushLimit(
  "member",
  values.memberTicketLimit,
  values.memberFoodLimit
)
    }

    if (values.isNonMember) {
      pushLimit(
  "non_member",
  values.nonMemberTicketLimit,
  values.nonMemberFoodLimit
)
    
    }

  

    

    return limits
  }

  const buildPayload = (values, isFinal = false) => {

    const foodCategories = [
      values.enable_veg && "veg",
      values.enable_nonveg && "non_veg",
      values.enable_vegan && "vegan",
    ].filter(Boolean)

    const formattedParking = (values.parking || []).map(item => ({
      parking_name: item.parking_name || null,
      parking_address: item.parking_address || null,
      latitude: item.latitude ? Number(item.latitude) : null,
      longitude: item.longitude ? Number(item.longitude) : null,
      vehicle_type: item.vehicleType ? [item.vehicleType] : ["car"],
      capacity: item.capacity ? Number(item.capacity) : 0,
      googleMap: item.googleMap || false,
    }))

    const formattedTicketPricing = {
      pricing: Object.entries(values.ticketPricing || {}).map(
        ([category, prices]) => {
          const parts = category.split("_")
          return {
            age_group: parts[0],
            audience_type: parts.slice(1).join("_"),
            early_bird_cost: prices?.early ? Number(prices.early) : 0,
            standard_cost: prices?.standard ? Number(prices.standard) : 0,
          }
        }
      ),
    }

    const foodPricingSource =
      values.bookingType === "ticket_food_booking"
        ? values.ticketFoodPricing
        : values.foodPricing

    const formattedFoodPricing = Object.entries(foodPricingSource || {}).map(
      ([foodType, categories]) => ({
        food_type: foodType,
        pricing: Object.entries(categories || {}).map(([category, prices]) => {
          const parts = category.split("_")

          return {
            age_group: parts[0],
            audience_type: parts.slice(1).join("_"),
            early_bird_cost: prices?.early ? Number(prices.early) : 0,
            standard_cost: prices?.standard ? Number(prices.standard) : 0,
          }
        }),
      })
    )

    const bookingTypeMapping = {
      ticket_booking: "ticket",
      food_booking: "food",
      ticket_food_booking: "ticket_food",
    }
    const formattedSessions = (values.sessions || []).map(session => ({
      session_name: session.sessionName || null,
      description: session.description || null,
      zone: session.zone || null,

      start_datetime: session.startDateTime
        ? new Date(session.startDateTime).toISOString()
        : null,

      end_datetime: session.endDateTime
        ? new Date(session.endDateTime).toISOString()
        : null,

      session_gate_scanning: session.gateScanning || false,
    }))

    const formattedFoodItems = (values.food_items || []).map(item => ({
      category: item.category || null,
      item_name: item.itemName || null,
      description: item.description || null,
    }))

    let finalPayload = {
      _id: draftVenueId || undefined,
      is_draft: !isFinal,

      master_event_id: event_id_c?.EventId,
      venue_id: venue_id_c?._id || validation.values.venue_id || undefined,
      venue: values.venue,
      address: values.address,
      max_tickets: Number(values.max_tickets),


      start_datetime: toUTCISOString(values.start_datetime),
end_datetime: toUTCISOString(values.end_datetime),


      // start_datetime: values.start_datetime
      //   ? new Date(values.start_datetime).toISOString()
      //   : null,

      // end_datetime: values.end_datetime
      //   ? new Date(values.end_datetime).toISOString()
      //   : null,

      enable_google_map: values.enable_google_map || false,
      venue_google_map:
        values.enable_google_map && values.venue_google_map
          ? {
            latitude: values.venue_google_map.latitude
              ? Number(values.venue_google_map.latitude)
              : null,
            longitude: values.venue_google_map.longitude
              ? Number(values.venue_google_map.longitude)
              : null,
            map_address: values.venue_google_map.map_address || null,
          }
          : null,
      enable_venue_organizer: values.enable_venue_organizer || false,
      venue_organizer: values.enable_venue_organizer
        ? (values.venue_organizer || []).map(org => ({
          organizer_name: org.organizer_name || null,
          contact_number: org.contact_number || null,
          role: org.role || null,
          email: org.email || null,
          active_status: org.active_status || "active",
          created_by: org.created_by || null,
        }))
        : [],

      enable_early_bird: values.enable_early_bird || false,
      enable_food: values.enable_food || false,

      earlybird_end_datetime: values.earlyBirdEndDate
        ? new Date(values.earlyBirdEndDate).toISOString()
        : null,

      // booking_open_on: values.bookingOpen
      //   ? new Date(values.bookingOpen).toISOString()
      //   : null,

      // booking_closed_on: values.bookingClose
      //   ? new Date(values.bookingClose).toISOString()
      //   : null,
      booking_open_on: toUTCISOString(values.bookingOpen),
booking_closed_on: toUTCISOString(values.bookingClose),

      booking_type: bookingTypeMapping[values.bookingType] || "ticket",
      enable_booking: values.enableTicketBooking,

      enable_reserved_seating: values.enable_early_bird || false,
      reserved_seat: values.enable_early_bird
        ? Number(values.reserved_seat)
        : null,

      audience_types: values.audienceType,
      booking_limits: buildBookingLimits(values),
      age_groups: values.ageGroup,

      enable_parking: values.enable_parking || false,
      parking: values.enable_parking ? formattedParking : [],

      enable_food_menu: values.enable_food_menu || false,

      food_categories: values.enable_food ? foodCategories : [],

      required_registration: values.required_registration || {},
      food_items: formattedFoodItems,
      ticket_delivery_channels: values.deliveryChannels || [],

      enable_session: values.enable_sessions || false,
      session: formattedSessions,

      access_control: {
        enable_qr_barcode: values.enableQR || false,
        enable_venue_gate_scanning: values.enableVenueScan || false,
        enable_session_gate_scanning: values.enableSessionScan || false,
        enable_id_card: values.enableID || false,
      },
    }

    switch (values.bookingType) {
      case "ticket_booking":
        finalPayload.ticket_pricing = formattedTicketPricing
        finalPayload.food_pricing = null
        break

      case "food_booking":
        // finalPayload.ticket_pricing = null
        // finalPayload.food_pricing = formattedFoodPricing
        finalPayload.ticket_pricing = { pricing: [] }; // Object with array in schema
    finalPayload.food_pricing = formattedFoodPricing;
        break

      case "ticket_food_booking":
        finalPayload.ticket_pricing = formattedTicketPricing
        finalPayload.food_pricing = formattedFoodPricing
        break

      default:
        finalPayload.ticket_pricing = null
        finalPayload.food_pricing = null
    }

    return finalPayload
  }

  const saveStepData = async (isFinal = false) => {
    const payload = buildPayload(validation.values, isFinal)

    try {
      const response = await dispatch(createTicketVenue(payload))

      const savedVenue = response?.payload?.data

      if (savedVenue?._id) {
        setDraftVenueId(savedVenue._id)

        localStorage.setItem("venueDraftId", savedVenue._id)

        validation.setFieldValue("_id", savedVenue._id)
      }

      if (savedVenue?.venue_id) {
        validation.setFieldValue("venue_id", savedVenue.venue_id)
      }
    } catch (err) {
      console.error("Error saving venue or updating payment keys:", err)
    }
  }
const toLocalInput = (utcDate) => {
  if (!utcDate) return "";

  const date = new Date(utcDate);
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60000);

  return local.toISOString().slice(0, 16);
};

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      master_event_id: selectedData?.master_event_id || "",
      venue_id: selectedData?.venue_id || venue_id_c?._id || "",
      address: selectedData?.address || "",
//       start_datetime: toLocalDateTime(selectedData?.start_datetime),
// end_datetime: toLocalDateTime(selectedData?.end_datetime),

start_datetime: toLocalInput(selectedData?.start_datetime),
end_datetime: toLocalInput(selectedData?.end_datetime),


      // start_datetime: selectedData?.start_datetime
      //   ? new Date(selectedData.start_datetime).toISOString().slice(0, 16)
      //   : "",

      // end_datetime: selectedData?.end_datetime
      //   ? new Date(selectedData.end_datetime).toISOString().slice(0, 16)
      //   : "",
      max_tickets: selectedData?.max_tickets || "",
      enable_early_bird: selectedData?.enable_early_bird || false,
      ticketPricing:
        selectedData?.ticket_pricing?.pricing?.reduce((acc, curr) => {
          const key = `${curr.age_group}_${curr.audience_type}`
          acc[key] = {
            early: curr.early_bird_cost || "",
            standard: curr.standard_cost || "",
          }
          return acc
        }, {}) || {},

      venue_google_map: selectedData?.venue_google_map || {
        latitude: "",
        longitude: "",
        map_address: "",
      },
      enable_google_map: selectedData?.enable_google_map || false,

      enable_venue_organizer: selectedData?.enable_venue_organizer || false,
      venue_organizer: selectedData?.venue_organizer?.length
        ? selectedData.venue_organizer.map(org => ({
          organizer_name: org.organizer_name || "",
          contact_number: org.contact_number || "",
          role: org.role || "",
          email: org.email || "",
          active_status: org.active_status || "active",
          created_by: org.created_by || null,
        }))
        : [],

      foodPricing: selectedData?.food_pricing?.reduce((acc, food) => {
        acc[food.food_type] = {}

        food.pricing.forEach(row => {
          const key = `${row.age_group}_${row.audience_type}`
          acc[food.food_type][key] = {
            early: row.early_bird_cost || "",
            standard: row.standard_cost || "",
          }
        })

        return acc
      }, {}) || {
        veg: {},
        non_veg: {},
        vegan: {},
      },
 

      ticketFoodPricing: selectedData?.food_pricing?.reduce((acc, food) => {
    acc[food.food_type] = {};
    food.pricing.forEach(row => {
        const key = `${row.age_group}_${row.audience_type}`.toLowerCase().replace(/ /g, "_");
        acc[food.food_type][key] = {
            early: row.early_bird_cost || "",
            standard: row.standard_cost || "",
        };
    });
    return acc;
}, { veg: {}, non_veg: {}, vegan: {} }) || { veg: {}, non_veg: {}, vegan: {} },

      enable_food_menu: selectedData?.enable_food_menu || false,

      food_items: selectedData?.food_items?.map(item => ({
        category: item.category || "Veg",
        itemName: item.item_name || "",
        description: item.description || "",
      })) || [
          {
            category: "Veg",
            itemName: "",
            description: "",
          },
        ],
      isMember: selectedData?.audience_types?.includes("member") || false,
      isNonMember:
        selectedData?.audience_types?.includes("non_member") || false,
      // isSponsor: selectedData?.audience_types?.includes("sponsor") || false,

      isAdult: selectedData?.age_groups?.includes("adult") || false,
      isChild: selectedData?.age_groups?.includes("child") || false,

      audienceType: selectedData?.audience_types || [],
      ageGroup: selectedData?.age_groups || [],

      memberTicketLimit:
        selectedData?.booking_limits?.find(l => l.audience_type === "member")
          ?.max_tickets_per_booking || "",

      nonMemberTicketLimit:
        selectedData?.booking_limits?.find(l => l.audience_type === "non_member")
          ?.max_tickets_per_booking || "",

          memberFoodLimit:
  selectedData?.booking_limits?.find(l => l.audience_type === "member")
    ?.max_food_per_booking || "",

nonMemberFoodLimit:
  selectedData?.booking_limits?.find(l => l.audience_type === "non_member")
    ?.max_food_per_booking || "",

  
      enable_veg: selectedData?.food_categories?.includes("veg") || false,

      enable_nonveg: selectedData?.food_categories?.includes("non_veg") || false,

      enable_vegan: selectedData?.food_categories?.includes("vegan") || false,

      enableTicketBooking: selectedData?.enable_booking || false,

      deliveryChannels: selectedData?.ticket_delivery_channels || [],

      enableQR: selectedData?.access_control?.enable_qr_barcode || false,

      enableVenueScan:
        selectedData?.access_control?.enable_venue_gate_scanning || false,

      enableSessionScan:
        selectedData?.access_control?.enable_session_gate_scanning || false,

      enableID: selectedData?.access_control?.enable_id_card || false,


      reserved_seat: selectedData?.reserved_seat || "",

      bookingType:
        selectedData?.booking_type === "ticket"
          ? "ticket_booking"
          : selectedData?.booking_type === "food"
            ? "food_booking"
            : selectedData?.booking_type === "ticket_food"
              ? "ticket_food_booking"
              : "",
// earlyBirdEndDate: selectedData?.earlybird_end_datetime
//   ? new Date(selectedData.earlybird_end_datetime).toISOString().slice(0, 16)
//   : "",
earlyBirdEndDate: selectedData?.earlybird_end_datetime
  ? new Date(selectedData.earlybird_end_datetime).toISOString()
  : "",
  
      // earlyBirdEndDate: selectedData?.earlybird_end_datetime
      //   ? new Date(selectedData.earlybird_end_datetime)
      //     .toISOString()
      //     .slice(0, 10)
      //   : "",

      // bookingOpen: selectedData?.booking_open_on
      //   ? new Date(selectedData.booking_open_on).toISOString().slice(0, 16)
      //   : "",

      // bookingClose: selectedData?.booking_closed_on
      //   ? new Date(selectedData.booking_closed_on).toISOString().slice(0, 16)
      //   : "",
      bookingOpen: toLocalDateTime(selectedData?.booking_open_on),
bookingClose: toLocalDateTime(selectedData?.booking_closed_on),

      venue: selectedData?.venue || "",
      enable_parking: selectedData?.enable_parking || false,

      parking: selectedData?.parking?.map(p => ({
        parking_name: p.parking_name || "",
        parking_address: p.parking_address || "",
        latitude: p.latitude || "",
        longitude: p.longitude || "",
        vehicleType: p.vehicle_type?.[0] || "car",
        capacity: p.capacity || "",
        googleMap: p.googleMap || false,
      })) || [
          {
            parking_name: "",
            parking_address: "",
            latitude: "",
            longitude: "",
            vehicleType: "car",
            capacity: "",
            googleMap: false,
          },
        ],
      enable_sessions: selectedData?.enable_session || false,

      sessions: selectedData?.session?.map(s => ({
        sessionName: s.session_name || "",
        description: s.description || "",
        zone: s.zone || "",

        startDateTime: s.start_datetime
          ? new Date(s.start_datetime).toISOString().slice(0, 16)
          : "",

        endDateTime: s.end_datetime
          ? new Date(s.end_datetime).toISOString().slice(0, 16)
          : "",

        gateScanning: s.session_gate_scanning || false,
      })) || [
          {
            sessionName: "",
            description: "",
            zone: "",
            startDateTime: "",
            endDateTime: "",
            gateScanning: false,
          },
        ],
      required_registration: {
        enable_first_name:
          selectedData?.required_registration?.enable_first_name || false,

        enable_last_name:
          selectedData?.required_registration?.enable_last_name || false,

        enable_mail_id:
          selectedData?.required_registration?.enable_mail_id || false,

        enable_mobile_number:
          selectedData?.required_registration?.enable_mobile_number || false,

        enable_age:
          selectedData?.required_registration?.enable_age || false,
      },
      enable_food: selectedData?.enable_food || false,
    },

    validationSchema: Yup.object({
      venue: Yup.string().trim().required("Venue name is required"),

      address: Yup.string().trim().required("Venue address is required"),

      // start_datetime: Yup.date().required("Start date & time is required"),

      // end_datetime: Yup.date()
      //   .required("End date & time is required")
      //   .min(
      //     Yup.ref("start_datetime"),
      //     "End date & time cannot be before start date & time"
      //   ),
      start_datetime: Yup.date()
  .required("Start date & time is required")
  .min(new Date(), "Start date & time cannot be in the past"),

end_datetime: Yup.date()
  .required("End date & time is required")
  .test(
    "is-after-start",
    "End date & time must be after start date & time",
    function (value) {
      const { start_datetime } = this.parent;
      // Only validate if both dates are present
      return !start_datetime || !value || new Date(value) > new Date(start_datetime);
    }
  ),

      max_tickets: Yup.number()
        .typeError("Venue capacity must be a number")
        .required("Venue capacity is required")
        .min(1, "Venue capacity must be at least 1"),
      // bookingType: Yup.string().when("enableTicketBooking", {
      //   is: true,
      //   then: schema => schema.required("Booking type is required"),
      // }),
      bookingType: Yup.string().when("enableTicketBooking", {
  is: true,
  then: (schema) => schema.required("Please select a booking type"),
  otherwise: (schema) => schema.notRequired().nullable(),
}),



      bookingOpen: Yup.string().when("enableTicketBooking", {
        is: true,
        then: schema => schema.required("Booking open date is required"),
      }),

      bookingClose: Yup.string().when("enableTicketBooking", {
        is: true,
        then: schema =>
          schema
            .required("Booking close date is required")
            .test(
              "is-after-open",
              "Booking close must be after booking open",
              function (value) {
                const { bookingOpen } = this.parent
                if (!bookingOpen || !value) return true
                return new Date(value) > new Date(bookingOpen)
              }
            ),
      }),

      earlyBirdEndDate: Yup.string().when("enable_early_bird", {
        is: true,
        then: schema => schema.required("Early bird end date is required"),
      }),

      enable_parking: Yup.boolean(),

      parking: Yup.array().when("enable_parking", {
        is: true,
        then: Yup.array()
          .min(1, "Please add at least one parking entry")
          .of(
            Yup.object().shape({
              vehicleType: Yup.string().required("Vehicle type is required"),

              capacity: Yup.number()
                .typeError("Capacity must be a number")
                .required("Capacity is required")
                .min(1, "Capacity must be at least 1"),

              parking_name: Yup.string().required("Parking name is required"),

              parking_address: Yup.string().required(
                "Parking address is required"
              ),
            })
          ),

        otherwise: Yup.array().notRequired(),
      }),

      enable_venue_organizer: Yup.boolean(),
      memberFoodLimit: Yup.number().when("bookingType", {
  is: (val) => val === "food_booking" || val === "ticket_food_booking",
  then: (schema) =>
    schema.required("Food limit is required").min(1, "Must be at least 1"),
  otherwise: (schema) => schema.nullable().notRequired(),
}),

nonMemberFoodLimit: Yup.number().when(
  ["bookingType", "isNonMember"],
  {
    is: (type, isNonMember) =>
      (type === "food_booking" || type === "ticket_food_booking") &&
      isNonMember,
    then: (schema) =>
      schema
        .required("Non-member food limit is required")
        .min(1, "Must be at least 1"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }
),

      venue_organizer: Yup.array().when("enable_venue_organizer", {
        is: true,
        then: Yup.array()
          .min(1, "Please add at least one organizer")
          .of(
            Yup.object().shape({
              organizer_name: Yup.string().required(
                "Organizer name is required"
              ),
              contact_number: Yup.string().required(
                "Contact number is required"
              ),
              role: Yup.string().required("Role is required"),
              email: Yup.string()
                .email("Invalid email")
                .required("Email is required"),
            })
          ),
        otherwise: Yup.array().notRequired(),
      }),
      enable_sessions: Yup.boolean(),

      sessions: Yup.array().when("enable_sessions", {
        is: true,
        then: Yup.array()
          .min(1, "At least one session is required")
          .of(
            Yup.object().shape({
              sessionName: Yup.string().required("Session name is required"),
              zone: Yup.string().required("Zone is required"),
              description: Yup.string().required("Description is required"),
              startDateTime: Yup.string().required("Start time is required"),
              endDateTime: Yup.string().required("End time is required"),

              // Scan is optional
              gateScanning: Yup.boolean(),
            })
          ),
        otherwise: Yup.array().notRequired(),
      }),

  
foodPricing: Yup.object().test(
  "food-pricing-validation",
  "Required",
  function (value) {
    const { 
      enable_veg, enable_nonveg, enable_vegan, 
      isAdult, isChild, isMember, isNonMember,
      bookingType, enable_early_bird 
    } = this.parent;

    // Only validate if the booking type is exactly 'food_booking'
    if (bookingType !== 'food_booking') return true;

    const dietaryMap = { veg: enable_veg, non_veg: enable_nonveg, vegan: enable_vegan };
    const ageGroups = [];
    if (isAdult) ageGroups.push("adult");
    if (isChild) ageGroups.push("child");

    const audienceTypes = [];
    if (isMember) audienceTypes.push("member");
    if (isNonMember) audienceTypes.push("non_member");

    let errorContexts = [];

    Object.keys(dietaryMap).forEach((diet) => {
      if (dietaryMap[diet]) {
        ageGroups.forEach((age) => {
          audienceTypes.forEach((audience) => {
            const key = `${age}_${audience}`;
            const pricing = value?.[diet]?.[key];

            // 1. Standard Cost Validation
            if (pricing?.standard === "" || pricing?.standard === undefined || Number(pricing.standard) < 0) {
              errorContexts.push(this.createError({
                path: `foodPricing.${diet}.${key}.standard`,
                message: "Required"
              }));
            }

            // 2. Early Bird Validation (Only if enable_early_bird is true)
            if (enable_early_bird && (pricing?.early === "" || pricing?.early === undefined || Number(pricing.early) < 0)) {
              errorContexts.push(this.createError({
                path: `foodPricing.${diet}.${key}.early`,
                message: "Required"
              }));
            }
          });
        });
      }
    });

    // CRITICAL FIX: Return the first specific error context so Formik can map it to the field
    return errorContexts.length > 0 ? errorContexts[0] : true;
  }
),
ticketPricing: Yup.object().test(
  "ticket-pricing-validation",
  "Required",
  function (value) {
    const { isAdult, isChild, isMember, isNonMember, bookingType, enableTicketBooking,enable_early_bird } = this.parent;

    if (!enableTicketBooking) return true;

    if (bookingType === 'food_booking') return true;

    const ageGroups = [];
    if (isAdult) ageGroups.push("adult");
    if (isChild) ageGroups.push("child");

    const audienceTypes = [];
    if (isMember) audienceTypes.push("member");
    if (isNonMember) audienceTypes.push("non_member");

    let errorContexts = [];

    ageGroups.forEach((age) => {
      audienceTypes.forEach((audience) => {
        const key = `${age}_${audience}`;
        const pricing = value?.[key];

        // Standard Cost
        if (pricing?.standard === "" || pricing?.standard === undefined || Number(pricing.standard) < 0) {
          errorContexts.push(this.createError({
            path: `ticketPricing.${key}.standard`,
            message: "Required"
          }));
        }

        // Early Bird (NEW CHECK)
        if (enable_early_bird && (pricing?.early === "" || pricing?.early === undefined || Number(pricing.early) < 0)) {
          errorContexts.push(this.createError({
            path: `ticketPricing.${key}.early`,
            message: "Required"
          }));
        }
      });
    });

    return errorContexts.length > 0 ? errorContexts[0] : true;
  }
),

ticketFoodPricing: Yup.object().test(
  "ticket-food-pricing-validation",
  "Required",
  function (value) {
    const { enable_veg, enable_nonveg, enable_vegan, isAdult, isChild, isMember, isNonMember, bookingType, enable_early_bird } = this.parent;

    if (bookingType !== 'ticket_food_booking') return true;
 
    const dietaryMap = { veg: enable_veg, non_veg: enable_nonveg, vegan: enable_vegan };
    const activeAges = [];
    if (isAdult) activeAges.push("Adult");
    if (isChild) activeAges.push("Child");

    const activeAudiences = [];
    if (isMember) activeAudiences.push("Member");
    if (isNonMember) activeAudiences.push("Non Member");

    let errorContexts = [];

    Object.keys(dietaryMap).forEach((dietKey) => {
      if (dietaryMap[dietKey]) {
        activeAges.forEach((age) => {
          activeAudiences.forEach((audience) => {
            const categoryLabel = `${age} ${audience}`;
            const catKey = categoryLabel.toLowerCase().replace(/ /g, "_");
            const pricing = value?.[dietKey]?.[catKey];

            // Standard Cost
            if (pricing?.standard === "" || pricing?.standard === undefined || Number(pricing.standard) < 0) {
              errorContexts.push(this.createError({
                path: `ticketFoodPricing.${dietKey}.${catKey}.standard`,
                message: "Required"
              }));
            }

            // Early Bird (IMPROVED CHECK)
            if (enable_early_bird && (pricing?.early === "" || pricing?.early === undefined || Number(pricing.early) < 0)) {
              errorContexts.push(this.createError({
                path: `ticketFoodPricing.${dietKey}.${catKey}.early`,
                message: "Required"
              }));
            }
          });
        });
      }
    });

    return errorContexts.length > 0 ? errorContexts[0] : true;
  }
),

memberTicketLimit: Yup.number().when("bookingType", {
  is: (val) => val === "ticket_booking" || val === "ticket_food_booking",
  then: Yup.number().required("Ticket limit is required").min(1),
  otherwise: Yup.number().nullable().notRequired(), // This stops the "blocking"
}),
nonMemberTicketLimit: Yup.number().when(['bookingType', 'isNonMember'], {
  is: (type, isNonMember) => (type === 'ticket_booking' || type === 'ticket_food_booking') && isNonMember,
  then: (schema) => schema.required("Non-member ticket limit is required").min(1, "Must be at least 1"),
}), 
 
 
 
      enable_reserved_seating: Yup.boolean(),

      reserved_seat: Yup.number()
        .typeError("Reserved seat must be a number")
        .when("enable_reserved_seating", {
          is: true,
          then: schema =>
            schema
              .required(
                "Reserved seats are required when reserved seating is enabled"
              )
              .min(1, "Reserved seats must be at least 1")
              .test(
                "max-reserved",
                "Reserved seats cannot exceed venue capacity",
                function (value) {
                  const { max_tickets } = this.parent
                  return value <= max_tickets
                }
              ),
          otherwise: schema => schema.nullable().notRequired(),
        }),
    }),
    onSubmit: async (values, actions) => {
      try {
        await saveStepData(true)

        localStorage.removeItem("venueDraftId")
        localStorage.removeItem("editUser")

        setDraftVenueId(null)

        navigate("/venueticketlist")
      } catch (err) {
        console.error("Final save failed:", err)
      } finally {
        actions.setSubmitting(false)
      }
    },
  })
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const type = validation.values.bookingType

    // Ticket only
    if (type === "ticket_booking") {
      validation.setFieldValue("foodPricing", {
        veg: {},
        non_veg: {},
        vegan: {},
      })
    }

    // Food only
    if (type === "food_booking") {
      validation.setFieldValue("ticketPricing", {})
    }
  }, [validation.values.bookingType])

  const autoSaveTimer = useRef(null)

  useEffect(() => {
    if (isFirstRender.current) return
    if (!validation.dirty || validation.isSubmitting) return

    if (autoSaveTimer.current) {
      clearTimeout(autoSaveTimer.current)
    }

    autoSaveTimer.current = setTimeout(async () => {
      if (!validation.isSubmitting) {
        try {
          await saveStepData(false)
        } catch (err) {
          console.error("Auto save failed", err)
        }
      }
    }, 5000)

    return () => {
      if (autoSaveTimer.current) {
        clearTimeout(autoSaveTimer.current)
      }
    }
  }, [validation.values])

  const buildTicketFoodPricing = (dietaryPreferences, audienceTicketData) => {
    const result = {}

    const categories = []

    const { audienceType, ageGroup } = audienceTicketData || {}

    if (ageGroup?.adult) {
      if (audienceType?.member) categories.push("adult_member")
      if (audienceType?.nonMember) categories.push("adult_non_member")
      // if (audienceType?.sponsor) categories.push("adult_sponsor")
    }

    if (ageGroup?.child) {
      if (audienceType?.member) categories.push("child_member")
      if (audienceType?.nonMember) categories.push("child_non_member")
      // if (audienceType?.sponsor) categories.push("child_sponsor")
    }

    dietaryPreferences.forEach(food => {
      const foodKey = food.toLowerCase().replace(/-/g, "_")
      result[foodKey] = {}

      categories.forEach(cat => {
        result[foodKey][cat] = {
          early: "",
          standard: "",
        }
      })
    })

    return result
  }

  useEffect(() => {
    if (validation.values.bookingType !== "ticket_food_booking") return

    const existing = validation.values.ticketFoodPricing

    // if already populated (edit mode) do not overwrite
    if (existing && Object.keys(existing).length > 0) return

    const dietaryPreferences = [
      validation.values.enable_veg && "Veg",
      validation.values.enable_nonveg && "Non-Veg",
      validation.values.enable_vegan && "Vegan",
    ].filter(Boolean)

    const audienceTicketData = {
      audienceType: {
        member: validation.values.isMember,
        nonMember: validation.values.isNonMember,
        // sponsor: validation.values.isSponsor,
      },
      ageGroup: {
        adult: validation.values.isAdult,
        child: validation.values.isChild,
      },
    }

    const built = buildTicketFoodPricing(dietaryPreferences, audienceTicketData)

    validation.setFieldValue("ticketFoodPricing", built)
  }, [
    validation.values.enable_veg,
    validation.values.enable_nonveg,
    validation.values.enable_vegan,
    validation.values.isMember,
    validation.values.isNonMember,
    // validation.values.isSponsor,
    validation.values.isAdult,
    validation.values.isChild,
    validation.values.bookingType,
  ])

  useEffect(() => {
    const audience = {
      member: validation.values.isMember,
      nonMember: validation.values.isNonMember,
      // sponsor: validation.values.isSponsor,
    }

    const age = {
      adult: validation.values.isAdult,
      child: validation.values.isChild,
    }

    const categories = []

    if (age.adult) {
      if (audience.member) categories.push("adult_member")
      if (audience.nonMember) categories.push("adult_non_member")
      // if (audience.sponsor) categories.push("adult_sponsor")
    }

    if (age.child) {
      if (audience.member) categories.push("child_member")
      if (audience.nonMember) categories.push("child_non_member")
      // if (audience.sponsor) categories.push("child_sponsor")
    }

    // ---- TICKET PRICING CLEAN ----
    const currentTicket = validation.values.ticketPricing || {}
    const cleanedTicket = {}

    categories.forEach(cat => {
      cleanedTicket[cat] = currentTicket[cat] || { early: "", standard: "" }
    })

    if (JSON.stringify(currentTicket) !== JSON.stringify(cleanedTicket)) {
      validation.setFieldValue("ticketPricing", cleanedTicket)
    }

    // ---- FOOD PRICING CLEAN ----
    const currentFood = validation.values.foodPricing || {}
    const cleanedFood = {}

    Object.keys(currentFood).forEach(foodType => {
      cleanedFood[foodType] = {}

      categories.forEach(cat => {
        cleanedFood[foodType][cat] =
          currentFood?.[foodType]?.[cat] || { early: "", standard: "" }
      })
    })


    if (JSON.stringify(currentFood) !== JSON.stringify(cleanedFood)) {
      validation.setFieldValue("foodPricing", cleanedFood)
    }

    // ---- TICKET+FOOD CLEAN ----
    const currentTF = validation.values.ticketFoodPricing || {}
    const cleanedTF = {}

    Object.keys(currentTF).forEach(foodType => {
      cleanedTF[foodType] = {}

      categories.forEach(cat => {
        cleanedTF[foodType][cat] =
          currentTF?.[foodType]?.[cat] || { early: "", standard: "" }
      })
    })


    if (JSON.stringify(currentTF) !== JSON.stringify(cleanedTF)) {
      validation.setFieldValue("ticketFoodPricing", cleanedTF)
    }
  }, [
    validation.values.isMember,
    validation.values.isNonMember,
    // validation.values.isSponsor,
    validation.values.isAdult,
    validation.values.isChild,
  ])

  const addParkingType = () => {
    const parking = validation.values.parking || []

    validation.setFieldValue("parking", [
      ...parking,
      {
        parking_name: "",
        parking_address: "",
        latitude: "",
        longitude: "",
        vehicleType: "car",
        capacity: "",
        googleMap: false,
      },
    ])
  }

  const removeParkingType = index => {
    const list = [...validation.values.parking]
    list.splice(index, 1)

    validation.setFieldValue("parking", list)
  }

  const addSession = () => {
    const sessions = validation.values.sessions || []

    validation.setFieldValue("sessions", [
      ...sessions,
      {
        sessionName: "",
        description: "",
        zone: "",
        startDateTime: "",
        endDateTime: "",
        gateScanning: false,
      },
    ])
  }

  const removeSession = index => {
    const sessions = validation.values.sessions || []

    const updatedSessions = sessions.filter((_, i) => i !== index)

    validation.setFieldValue("sessions", updatedSessions)
  }

  const addFoodItem = () => {
    const updated = [
      ...(validation.values.food_items || []),
      { category: "Veg", itemName: "", description: "" },
    ]

    validation.setFieldValue("food_items", updated)
  }

  const removeFoodItem = index => {
    const list = [...validation.values.food_items]
    list.splice(index, 1)

    validation.setFieldValue("food_items", list)
  }

  const [audienceTicketData, setAudienceTicketData] = useState(null)

  const handleAudienceTicketingData = () => {
    const data = {
      audienceType: {
        member: validation.values.isMember,
        nonMember: validation.values.isNonMember,
        // sponsor: validation.values.isSponsor,
      },
      ageGroup: {
        adult: validation.values.isAdult,
        child: validation.values.isChild,
      },
      ticketBooking: {
        enabled: validation.values.enableTicketBooking,
        bookingType: validation.values.bookingType,
        earlyBird: validation.values.enable_early_bird,
        bookingOpen: validation.values.bookingOpen,
        bookingClose: validation.values.bookingClose,
        earlybird_end_datetime: validation.values.earlybird_end_datetime,
      },
    }

    console.log("Selected Data:", data)

    setAudienceTicketData(data)
  }
  const ticketEnabled = validation.values.enableTicketBooking
  const bookingType = validation.values.bookingType

  const steps = [
    { label: "Venue" },
    { label: "Audience & Ticketing" },

    ...(ticketEnabled && bookingType === "ticket_booking"
      ? [{ label: "Ticket Pricing" }]
      : []),

    ...(ticketEnabled && bookingType === "food_booking"
      ? [{ label: "Food Pricing" }]
      : []),
    ...(ticketEnabled && bookingType === "ticket_food_booking"
      ? [{ label: "Ticket + Food Pricing" }]
      : []),

    ...(ticketEnabled ? [{ label: "Delivery & Access" }] : []),
  ].map((step, index) => ({
    id: index + 1,
    ...step,
  }))

  const currentStepIndex = steps.findIndex(s => s.id === activeStep)
  const dietaryPreferences = [
    validation.values.enable_veg && "Veg",
    validation.values.enable_nonveg && "Non-Veg",
    validation.values.enable_vegan && "Vegan",
  ].filter(Boolean)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="" breadcrumbItem="Ticket Venue Information" />
          <Row>
            <Form
              onSubmit={event => {
                event.preventDefault()
                validation.handleSubmit()
                 console.log("ERRORS:", validation.errors);

  if (Object.keys(validation.errors).length > 0) {
    console.log("BLOCKED ❌");
    return;
  }

  console.log("SUBMITTING ✅");
              }}
            >
              <Card className="shadow-sm">
                <CardBody>
                  {/* Page Header */}
                  <div className="d-flex align-items-center border-bottom pb-3 mb-4">
                    <div className="flex-grow-1">
                      <h5 className="mb-1 text-primary fw-bold">
                        <i className="mdi mdi-map-marker-outline me-2"></i>
                        {venue_id_c
                          ? event_id_c.EventName + " / " + venue_id_c.VenueName
                          : event_id_c.EventName}
                      </h5>
                      <small className="text-muted">Configure venue, ticketing, pricing and access settings</small>
                    </div>
                    <div className="flex-shrink-0 d-flex gap-2">
                      <Link to="/venueticketlist" className="btn btn-outline-secondary btn-sm">
                        <i className="mdi mdi-arrow-left me-1"></i>Back
                      </Link>
                      <Link to="#!" onClick={() => { }} className="btn btn-outline-secondary btn-sm">
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                    </div>
                  </div>
{Object.keys(validation.errors).length > 0 && validation.submitCount > 0 && (
    <Alert color="danger" className="mb-4 shadow-sm">
      <div className="d-flex align-items-center">
        <i className="mdi mdi-alert-circle-outline me-2 font-size-20"></i>
        <h6 className="mb-0 fw-bold">Please correct the following errors before submitting:</h6>
      </div>
      <hr className="my-2" />
      <ul className="mb-0 small ps-3">
        {Object.entries(validation.errors).map(([field, error]) => (
          <li key={field} className="mb-1">
             <strong>{field.replace(/_/g, ' ')}:</strong> {typeof error === 'string' ? error : "Contains invalid data"}
          </li>
        ))}
      </ul>
    </Alert>
  )}
                  {/* Step Wizard */}
                  <div className="mb-4 container">
                    <div className="d-flex align-items-center flex-wrap gap-0">
                      {steps.map((step, index) => (
                        <React.Fragment key={step.id}>
                          <div
                            onClick={() => setActiveStep(step.id)}
                            style={{ cursor: "pointer" }}
                            className="d-flex flex-column align-items-center"
                          >
                            <div
                              className={`d-flex align-items-center justify-content-center rounded-circle border-2 fw-bold`}
                              style={{
                                width: 36,
                                height: 36,
                                fontSize: 14,
                                backgroundColor:
                                  activeStep === step.id
                                    ? "#556ee6"
                                    : step.id < activeStep
                                      ? "#34c38f"
                                      : "#f8f9fa",
                                color:
                                  activeStep === step.id || step.id < activeStep
                                    ? "#fff"
                                    : "#74788d",
                                border: `2px solid ${activeStep === step.id
                                    ? "#556ee6"
                                    : step.id < activeStep
                                      ? "#34c38f"
                                      : "#ced4da"
                                  }`,
                                transition: "all 0.3s ease",
                              }}
                            >
                              {step.id < activeStep ? (
                                <i className="mdi mdi-check" style={{ fontSize: 16 }}></i>
                              ) : (
                                step.id
                              )}
                            </div>
                            <small
                              className="mt-1 text-center"
                              style={{
                                fontSize: 11,
                                fontWeight: activeStep === step.id ? 600 : 400,
                                color: activeStep === step.id ? "#556ee6" : "#74788d",
                                maxWidth: 80,
                                lineHeight: "1.2",
                              }}
                            >
                              {step.label}
                            </small>
                          </div>
                          {index < steps.length - 1 && (
                            <div
                              style={{
                                flex: 1,
                                height: 2,
                                minWidth: 20,
                                backgroundColor:
                                  step.id < activeStep ? "#34c38f" : "#ced4da",
                                marginBottom: 24,
                                transition: "background-color 0.3s ease",
                              }}
                            />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>

                  {/* Step Content */}
                  <div className="container">
                    {activeStep === 1 && (
                      <VenueStep
                        validation={validation}
                        openSection={openSection}
                        toggleSection={toggleSection}
                        addParkingType={addParkingType}
                        removeParkingType={removeParkingType}
                        addSession={addSession}
                        removeSession={removeSession}
                        addFoodItem={addFoodItem}
                        removeFoodItem={removeFoodItem}
                      />
                    )}

                    {activeStep === 2 && (
                      <AudianceAndTicketing
                        validation={validation}
                        onDataChange={handleAudienceTicketingData}
                      />
                    )}

                    {activeStep ===
                      steps.find(s => s.label === "Ticket Pricing")?.id &&
                      ticketEnabled &&
                      bookingType === "ticket_booking" && (
                        <TicketPricing
                          audienceTicketData={audienceTicketData}
                          validation={validation}
                        />
                      )}

                    {activeStep ===
                      steps.find(s => s.label === "Food Pricing")?.id &&
                      ticketEnabled &&
                      bookingType === "food_booking" && (
                        <FoodPricing
                          dietaryPreferences={dietaryPreferences}
                          audienceTicketData={{
                            audienceType: {
                              member: validation.values.isMember,
                              nonMember: validation.values.isNonMember,
                              // sponsor: validation.values.isSponsor,
                            },
                            ageGroup: {
                              adult: validation.values.isAdult,
                              child: validation.values.isChild,
                            },
                            ticketBooking: {
                              earlyBird: validation.values.enable_early_bird,
                            },
                          }}
                          validation={validation}
                        />
                      )}

                    {activeStep ===
                      steps.find(s => s.label === "Ticket + Food Pricing")?.id &&
                      ticketEnabled &&
                      bookingType === "ticket_food_booking" && (
                        <TicketFoodPricing
                          dietaryPreferences={dietaryPreferences}
                          audienceTicketData={{
                            audienceType: {
                              member: validation.values.isMember,
                              nonMember: validation.values.isNonMember,
                              // sponsor: validation.values.isSponsor,
                            },
                            ageGroup: {
                              adult: validation.values.isAdult,
                              child: validation.values.isChild,
                            },
                            ticketBooking: {
                              earlyBird: validation.values.enable_early_bird,
                            },
                          }}
                          validation={validation}
                        />
                      )}

                    {activeStep ===
                      steps.find(s => s.label === "Delivery & Access")?.id &&
                      ticketEnabled && (
                        <DeliveryAccess validation={validation} openSection={openSection} toggleSection={toggleSection} />
                      )}

                    {/* Navigation Buttons */}
                    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                      <div>
                        {activeStep > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setActiveStep(steps[currentStepIndex - 1].id)}
                          >
                            <i className="mdi mdi-arrow-left me-1"></i>Previous
                          </button>
                        )}
                      </div>
                      <div className="d-flex gap-2">
                        {activeStep === 1 && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setActiveStep(steps[currentStepIndex + 1].id)}
                          >
                            Next<i className="mdi mdi-arrow-right ms-1"></i>
                          </button>
                        )}

                        {activeStep === 2 && !ticketEnabled && (
                          <button type="submit" className="btn btn-success">
                            <i className="mdi mdi-check me-1"></i>Save & Submit
                          </button>
                        )}

                        {ticketEnabled &&
                          activeStep > 1 &&
                          activeStep !== steps[steps.length - 1].id && (
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => setActiveStep(steps[currentStepIndex + 1].id)}
                            >
                              Next<i className="mdi mdi-arrow-right ms-1"></i>
                            </button>
                          )}

                        {ticketEnabled &&
                          activeStep === steps[steps.length - 1].id && (
                            <button type="submit" className="btn btn-success">
                              <i className="mdi mdi-check-circle me-1"></i>Save & Finish
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TicketVenue
